var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useViewerQuery, } from '../__generated__/graphql';
var ViewerContext = React.createContext(undefined);
export function ViewerProvider(props) {
    var _a = useViewerQuery(), loading = _a.loading, data = _a.data, refetch = _a.refetch;
    var value = {
        loading: loading,
        viewer: (data && data.viewer) || null,
        refetch: refetch,
        hasRole: function (role) {
            var viewer = data && data.viewer;
            if (loading) {
                throw new Error('Viewer must have finished loading before calling hasRole()');
            }
            if (!viewer) {
                throw new Error('Viewer query failed (viewer not found)');
            }
            return viewer.roles.includes(role);
        },
    };
    return _jsx(ViewerContext.Provider, __assign({ value: value }, props), void 0);
}
export function useViewer() {
    var context = React.useContext(ViewerContext);
    if (context === undefined) {
        throw new Error("useViewer must be used within a ViewerProvider");
    }
    return context;
}
//# sourceMappingURL=viewer-context.js.map